'use client';

import { motion } from 'framer-motion';
import { MatrixText } from './matrix-text';

interface AnimatedTitleProps {
  children: React.ReactNode;
  className?: string;
  mb?: string;
}

export function AnimatedTitle({ children, className = '', mb = 'mb-8' }: AnimatedTitleProps) {
  return (
    <div className={`relative uppercase text-[10px] font-normal ${mb} ${className}`}>
      <div className="relative overflow-hidden inline-block">
        {children}
        <motion.div
          className="absolute inset-0 bg-white"
          initial={{ left: 0, right: 'unset', width: '100%' }}
          animate={{
            left: '100%',
            right: 0,
            width: 0,
            transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 0.1 },
          }}
        />
      </div>
    </div>
  );
}

export function AnimatedLoading({ phrases }: { phrases?: string[] } = {}) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[555]">
      <MatrixText
        phrases={phrases || ['LOADING', 'LOADING', 'LOADING']}
        className="tracking-wider text-black text-xl"
        interval={1500}
        glitchProbability={0.05}
      />
    </div>
  );
}
